<template>
  <v-layout align-center column>
    <p class="Hero-Text">
      Informasi Lainnya
    </p>

    <img
      src="../../assets/SyaratKetentuan-Mobile/Hero.png"
      srcset="
        ../../assets/SyaratKetentuan-Mobile/Hero@2x.png 2x,
        ../../assets/SyaratKetentuan-Mobile/Hero@3x.png 3x
      "
      class="Hero"
    />
    <div class="d-flex justify-center mx-auto subText">
      Laporan Keuangan
    </div>
    <div class="d-flex justify-center mx-auto mt-8">
      <div class="d-flex flex-row">
        <v-btn
          v-for="(rep, i) in reports"
          :key="i"
          x-large
          color="#D3352C"
          dark
          rounded
          class="mx-2"
          @click="toDetail(rep)"
        >
          {{ rep }}
        </v-btn>
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      reports: [2020, 2021, 2022, 2023, 2024, 2025],
    };
  },
  methods: {
    toDetail(rep) {
      this.$router.push("informasi-lainnya/" + rep);
    },
  },
};
</script>
<style scoped>
.Hero {
  width: 100%;
  margin: 0 0 50px;
  object-fit: contain;
}
/* .Hero {
  width: 360px;
  height: 134px;
  margin: 0 0 50px;
  padding: 0 0 16px;
  object-fit: contain;
} */
.Hero-Text {
  /* width: 328px; */
  height: 30px;
  margin: 90px auto;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.48px;
  text-align: center;
  color: #252525;
  position: absolute;
}
.subText {
  font-size: 16px;
  font-weight: bold;
  color: #252525;
}
</style>
